export const MYACCOUNT_REQUESTING       = 'MYACCOUNT_REQUESTING'
export const MYACCOUNT_REQUEST_SUCCESS  = 'MYACCOUNT_REQUEST_SUCCESS'
export const MYACCOUNT_REQUEST_ERROR    = 'MYACCOUNT_REQUEST_ERROR'  

export const MYACCOUNT_POST_REQUESTING  = 'MYACCOUNT_POST_REQUESTING'
export const MYACCOUNT_POST_SUCCESS     = 'MYACCOUNT_POST_SUCCESS'
export const MYACCOUNT_POST_ERROR       = 'MYACCOUNT_POST_ERROR'  

export const MYACCOUNT_GET_PROFILE_API    = '/api/v1/users/getProfile'  
export const MYACCOUNT_POST_PROFILE_API    = '/api/v1/users/update_profile'  


// WEBPACK FOOTER //
// ./src/views/Pages/MyAccount/constants.js